// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"674c68f6","455":"5499bd80"}[chunkId] + ".chunk.js";
};